
















































import {Component, Inject, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CDatepicker from '@/components/base/datepicker/CDatepicker.vue';
import CTable from '@/components/base/table/CTable.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import WarehouseVeneerAuditEditDialogContent from '@/views/journals/warehouseVeneerAudit/WarehouseVeneerAuditEditDialogContent.vue';
@Component({
    components: {
        WarehouseVeneerAuditEditDialogContent,
        CCheckbox,
        CNumberField,
        CTable,
        CDatepicker,
        CSelect,
        CEditDialog,
    },
})
export default class WarehouseVeneerAuditCreateDialog extends Mixins(EditDialogMixin) {
    @Inject() getVocabulary!: Function;
    private model = 1;
    private steps = 2;
    private date = Date.now();
    private idWarehouse: null | number = null;
    private continueLoading = false;
    private vocabulary: Map<string, Map<number, string>> | null = null;

    init() {
        let date = new Date(Date.now());
        date.setSeconds(0);
        date.setMilliseconds(0);
        this.date = Date.parse(date.toISOString());
        this.idWarehouse = null;
    }

    afterClose() {
        this.model = 1;
    }

    async onContinue() {
        this.continueLoading = true;
        try {
            const response = await Promise.all([
                this.$http.get(`${this.$api.journals.warehouseVeneerAudit}/GetCreate`, {
                    params: {
                        creationDate: this.date,
                        idWarehouseVeneer: this.idWarehouse,
                    },
                }),
                this.getVocabulary(this),
            ]);
            this.data = response[0].data;
            this.vocabulary = response[1];
            this.model = 2;
        } finally {
            this.continueLoading = false;
        }
    }
}
